const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowAccessibilityNavLinks', ['BreakpointsService', require('./accessibility-nav-links.directive')]);



// WEBPACK FOOTER //
// ./src/shop/accessibility/index.js